module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/146.c019218f.png";